var _circle, _circle2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnSnsLoginGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 25.5,
    stroke: "#222",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.052 26.817a15.525 15.525 0 0 0-.26-2.885H26.495v5.46h7.602a6.511 6.511 0 0 1-2.81 4.26v3.54h4.556a13.742 13.742 0 0 0 4.21-10.375z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.495 40.61a13.495 13.495 0 0 0 9.348-3.418l-4.556-3.54A8.542 8.542 0 0 1 26.495 35a8.431 8.431 0 0 1-7.899-5.82h-4.704v3.653a14.09 14.09 0 0 0 12.603 7.775z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.596 29.182a8.544 8.544 0 0 1 0-5.373v-3.653h-4.705a14.053 14.053 0 0 0 0 12.678l4.705-3.652z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.495 17.99a7.614 7.614 0 0 1 5.398 2.117l4.049-4.049a13.545 13.545 0 0 0-9.447-3.714 14.09 14.09 0 0 0-12.604 7.775l4.705 3.652a8.432 8.432 0 0 1 7.9-5.819v.038z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnSnsLoginGoogle);
export default __webpack_public_path__ + "static/media/btn_sns_login_google.9149e7d391cffcd48af16d67d57a6610.svg";
export { ForwardRef as ReactComponent };